(function ($) {

    $('.js-slick-methods').slick({
        dots: false,
        prevArrow: $('.slick-arrow-prev-methods-template-caret'),
        nextArrow: $('.slick-arrow-next-methods-template-caret'),
        slidesToShow: 5
    });

    $('.js-slick').slick({
        dots: true,
        prevArrow: $('.slick-arrow-prev-template'),
        nextArrow: $('.slick-arrow-next-template'),
    });

    $('.js-slick-caret').slick({
        dots: true,
        prevArrow: $('.slick-arrow-prev-template-caret'),
        nextArrow: $('.slick-arrow-next-template-caret'),
    });

    $('.js-slick-caret-testimonials').slick({
        dots: true,
        centerMode: true,
        centerPadding: '0px',
        Infinity: true,
        prevArrow: $('.slick-arrow-prev-template-caret'),
        nextArrow: $('.slick-arrow-next-template-caret'),
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 1100,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 4500,
            settings: {
                slidesToShow: 3
            }
        }]
    });

    // Pagination Arrows
    // $('.wp-paginate .prev').prepend('<svg width="11" height="8" viewBox="0 0 11 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.97631 4.7308 0.659728 4.53553 0.464466C4.34027 0.269203 4.02369 0.269203 3.82843 0.464465L0.646447 3.64645ZM11 3.5L1 3.5L1 4.5L11 4.5L11 3.5Z" fill="currentColor"/></svg>');

    // $('.wp-paginate .next').append('<svg width="11" height="8" viewBox="0 0 11 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M10.3536 4.35355C10.5488 4.15829 10.5488 3.84171 10.3536 3.64644L7.17157 0.464465C6.97631 0.269203 6.65973 0.269203 6.46447 0.464465C6.2692 0.659727 6.2692 0.97631 6.46447 1.17157L9.29289 4L6.46447 6.82843C6.2692 7.02369 6.2692 7.34027 6.46447 7.53553C6.65973 7.73079 6.97631 7.73079 7.17157 7.53553L10.3536 4.35355ZM8.74228e-08 4.5L10 4.5L10 3.5L-8.74228e-08 3.5L8.74228e-08 4.5Z" fill="currentColor"/></svg>');
}(jQuery));